import {
  REACT_APP_API_URL,
  REACT_APP_AUDIT_SVC,
  REACT_APP_HEALTH_CHECK_URL,
  REACT_APP_OAUTH2_AUDIENCE,
  REACT_APP_OAUTH2_CLIENTID,
  REACT_APP_OOLIO_DOMAIN,
  REACT_APP_SUBSCRIPTION_URI,
} from 'react-native-dotenv';
import { getEmbeddedBoot } from './embedded/embedded';

const embedded = getEmbeddedBoot()?.config;

const config = {
  API_URL:
    embedded?.apiUrl || process.env['REACT_APP_API_URL'] || REACT_APP_API_URL,
  AUDIT_SVC_URL:
    embedded?.auditUrl ||
    process.env['REACT_APP_AUDIT_SVC'] ||
    REACT_APP_AUDIT_SVC ||
    '',
  SUBSCRIPTION__URL:
    embedded?.subscriptionUrl ||
    process.env['REACT_APP_SUBSCRIPTION_URI'] ||
    REACT_APP_SUBSCRIPTION_URI,
  HEALTH_CHECK_URL:
    embedded?.healthCheckUrl ||
    process.env['REACT_APP_HEALTH_CHECK_URL'] ||
    REACT_APP_HEALTH_CHECK_URL ||
    'https://ok.oolio.io',
  auth0: {
    issuer:
      'https://auth.' +
      (process.env['REACT_APP_OOLIO_DOMAIN'] || REACT_APP_OOLIO_DOMAIN),
    clientId:
      process.env['REACT_APP_OAUTH2_CLIENTID'] || REACT_APP_OAUTH2_CLIENTID,
    redirectUrl: '',
    additionalParameters: {
      audience:
        process.env['REACT_APP_OAUTH2_AUDIENCE'] || REACT_APP_OAUTH2_AUDIENCE,
    },
    scopes: ['openid', 'profile', 'email', 'offline_access'],
  },
};

export default config;
